import React, {useEffect, useState} from "react";
import {useInView} from "react-intersection-observer";
import FeatherIcon from "feather-icons-react";
import {getInitials} from "../constants";

const PreImage = ({src, width, height, marginTop=null, noPhoto=true, is_authorized=true, fallbackLabel=null} ) => {
    const [imageLoaded, setImageLoaded] = useState(false)
    const [noImage, setNoImage] = useState(false)
    const aspectRatio = (height / width) * 100;
    const { ref, inView } = useInView({
        threshold: 0.1,
        triggerOnce: true
    })
    useEffect(() => {
        if (src !== "no") {
            const img = new Image()
            img.onload = () => {
                setTimeout(() => {setImageLoaded(true)}, 200)
            }
            img.src = src
        }
        else {
            setNoImage(true)
        }
    }, [src]);
    return <>
            <div
                ref={ref}
                className={`image-blur-bg ${!imageLoaded ? "color" : ""}`}
                style={{ margin: 0, padding: 0, paddingTop: `${aspectRatio}%`}}
            >
                <div className={`image-blur ${(imageLoaded && inView) ? "image-show" : "image-hide"}`}>
                    <img
                        src={ src }
                        style={{ marginTop: marginTop }}
                    />
                </div>
                {
                    noPhoto &&
                    <div className={`no-image-blur ${(noImage && inView) ? "image-show" : "image-hide"}`}>
                        {fallbackLabel
                            ? <span className="thumb-initials">{getInitials(fallbackLabel)}</span>
                            : <FeatherIcon icon="camera-off" />
                        }
                    </div>
                }
                {
                    !src && !is_authorized &&
                    <div className={`no-image-blur ${!is_authorized ? "non_authorized" : ""}`}>
                        <FeatherIcon icon="camera-off" />
                    </div>
                }
            </div>
        </>
}

export default PreImage
